import React from 'react';
import './styles.css';

const RecruiterProcess = props => {
  return <article className="recruiter-process">{props.children}</article>;
};

export default RecruiterProcess;
